import { request } from "./request";

export function getWeather() {
  return request({
    headers:{
      Authorization:'Basic aHN4LXdlYXRoZXI6RkUwNzE1V0U='
    },
    method: "get",
    url: "/api/svc-weather/weather/getWeatherWX"
  });
}

export function getTyphoon() {
  return request({
    headers:{
      Authorization:'Basic aHN4LXdlYXRoZXI6RkUwNzE1V0U='
    },
    method: "get",
    url: "/api/svc-weather/weather/getTyphoon"
  });
}

export function getByPlaceName(params) {
  return request({
    headers:{
      Authorization:'Basic aHN4LXdlYXRoZXI6RkUwNzE1V0U='
    },
    // url: bindUrl("/weather/getByPlaceName", {}),
    // url: bindUrl("/weather/getByPlaceName", {}),
    url: "/api/svc-weather/weather/getByPlaceName",
    method: "GET",
    params
  });
}
